import { render, staticRenderFns } from "./IcpInfo.vue?vue&type=template&id=71489adb&scoped=true&"
import script from "./IcpInfo.vue?vue&type=script&lang=js&"
export * from "./IcpInfo.vue?vue&type=script&lang=js&"
import style0 from "./IcpInfo.vue?vue&type=style&index=0&id=71489adb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71489adb",
  null
  
)

export default component.exports